const Layout = ({ children }) => (
  <div className="min-h-screen bg-gray-100 flex flex-col">
    <header className="bg-[#890f20] w-full max-w-[1140px] px-4 mx-auto flex items-center justify-center">
      <img
        className="w-[200px] h-auto m-2"
        src="https://d1g6c01s9ssd7h.cloudfront.net/img/mayahii.blanco.png"
        alt="Logo"
      />
    </header>
    <div className="flex-grow w-full">{children}</div>
    <footer className="bg-[#890f20] w-full max-w-[1140px] px-4 mx-auto flex items-center justify-center">
      <img
        className="w-[100px] h-[40px] m-2"
        src="https://d1g6c01s9ssd7h.cloudfront.net/img/powered_Mayahii_blanco.png"
        alt="Logo"
      />
    </footer>
  </div>
);

export default Layout;
